import React from 'react'
import { useTranslation } from 'react-i18next'
import { type RecurringRepairSubscription } from '../types/recurring-repair.types'
import { formatCurrency } from '../../common/js/currency-utility'
import { localeDate } from '../../common/js/date-utility'
import CardBrandLogo from '../../common/components/payment-method/CardBrandLogo'

type Props = {
    subscription: RecurringRepairSubscription
}

export default function SubscriptionSummary({subscription}: Props) {
    const { t } = useTranslation('checkout')
    const curr = subscription ? subscription.currencyCode : 'USD';
    
    const subtotalFloat = subscription ? subscription.subtotal : 0;
    const subtotalVal = formatCurrency(subtotalFloat, curr);

    const taxFloat = subscription ? subscription.totalTaxes : 0;
    const taxVal = formatCurrency(taxFloat, curr);

    const totalFloat = subscription ? subscription.subtotal : 0;
    const totalVal = formatCurrency(totalFloat, curr);

    const renewalDate = subscription ? subscription.renewalDate : new Date().toISOString();
    const formattedRenewalDate = localeDate(renewalDate);

  return (
    <div className='subscription-summary box'>
        <h4 className='billing-header'>{t('subscription.yourSubscription')}</h4>
        <div className='totals-field'>
            <label>{t('subscription.renewalDate')}</label>
            <span>{formattedRenewalDate}</span>
        </div>
        {subscription && subscription.paymentMethodId && (
            <div className='totals-field'>
                <label>Card</label>
                <span><CardBrandLogo brand={subscription.cardBrand} /> Ending in {subscription.cardLastFour}</span>
            </div>
        )}
        <div className='totals-field'>
            <label>{t('subscription.renewalCost')}</label>
            <span>{subtotalVal}</span>
        </div>
        <div className='totals-field'>
            <label>{t('subscription.taxes')}</label>
            <span>{taxVal}</span>
        </div>
        <hr style={{borderColor: 'rgba(0, 0, 0, 12%)', borderStyle: 'dashed'}} />
        <div className='totals-field'>
            <label>{t('subscription.total')}</label>
            <span>{totalVal}</span>
        </div>
    </div>
  )
}